const SAME_ORIGIN = 'https://same-origin.invalid'

/** Same-origin path from a `next` param, else the fallback. Parsed as the browser will navigate it. */
export function safeNextPath(next: string | null | undefined, fallback: string): string {
  if (!next?.startsWith('/')) return fallback
  try {
    const target = new URL(next, SAME_ORIGIN)
    const path = target.pathname + target.search + target.hash
    // Dot segments can normalize "/.//host" to "//host", which navigates off-site.
    return target.origin === SAME_ORIGIN && !path.startsWith('//') ? path : fallback
  } catch {
    return fallback
  }
}
